import React, { useMemo } from 'react'
import Container from './container'
import { Image } from './Image'
import styles from './featured-investments.module.css'
import { Link } from 'gatsby'

const filterContent = (contentArray) => {
  if (!contentArray || contentArray.length === 0) {
    return []
  }

  const uniqueItems = contentArray.reduce((acc, current) => {
    const x = acc.find(item => item.company.title === current.company.title)
    if (!x) {
      acc.push(current)
    }
    return acc
  }, [])

  const result = JSON.parse(JSON.stringify(uniqueItems))

  result.sort((firstItem, secondItem) => {
    if (firstItem.order > secondItem.order) {
      return -1
    }
    if (firstItem.order < secondItem.order) {
      return 1
    }
    const firstTitle = firstItem.company.title.toUpperCase()
    const secondTitle = secondItem.company.title.toUpperCase()

    if (firstTitle < secondTitle) {
      return -1
    }
    if (firstTitle > secondTitle) {
      return 1
    }
    return 0
  })

  return result
}

function FeaturedInvestments ({ content = [], showExtended = false }) {
  const featuredCompanies = useMemo(() => {
    const sorted = filterContent(content)

    const numToShow = showExtended ? 6 : 4
    const top = sorted.slice(0, numToShow)

    // Display alphabetically
    top.sort((a, b) => {
      const at = (a?.company?.title || '').toUpperCase()
      const bt = (b?.company?.title || '').toUpperCase()
      if (at < bt) return -1
      if (at > bt) return 1
      return 0
    })

    return top
  }, [content])

  const handleScrollToCompanies = (e) => {
    e.preventDefault()
    const el = document.getElementById('companies')
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  if (!featuredCompanies.length) return null

  return (
    <Container size='large'>
      <section className={styles.featuredInvestmentsSection}>
        {/* <div className={styles.featuredInvestmentsTitle}>
          Featured <span>Investments</span>
        </div> */}

        <div className={`${styles.featuredInvestmentsGrid} ${showExtended ? styles.gridExtended : ''}`}>
          {featuredCompanies.map((item) => {
            const company = item?.company
            if (!company) return null

            const logo = company.logoColor
            if (!logo) return null

            return (
              <Link to={`/companies/${company.slug.current}/`}
                key={company._id || company.title}
                className={styles.featuredInvestmentsLogoCell}
              >
                <Image
                  imgObj={logo}
                  className={styles.featuredInvestmentsLogo}
                  props={{ mode: 'contain' }}
                />
              </Link>
            )
          })}
        </div>

        <div className={styles.featuredInvestmentsLinkWrap}>
          <a
            href='#companies'
            onClick={handleScrollToCompanies}
            className={styles.featuredInvestmentsLink}
          >
            View All Companies ↓
          </a>
        </div>
      </section>
    </Container>
  )
}

export default FeaturedInvestments
